import { CustomMap } from '../custom-map/custom-map';
import { List } from '../list/list';
import { CustomModal } from './custom-modal/custom-modal';

const Main = () => {
    return (
        <>
            <List />
            <CustomMap />
            <CustomModal />
        </>
    )
}

export default Main;